module.exports = __webpack_public_path__ + "static/media/84.7ac60360.webp";